export const transformInitialsInput = (event: React.FormEvent<HTMLInputElement>) => {
  event.currentTarget.value = ('' + event.currentTarget.value).toUpperCase()
}
